import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  TextField,
  Button,
  useMediaQuery,
  useTheme,
  Stack,
} from "@mui/material";
import isMobile from "../isMobile";
import { isProductExpired } from "../api/productUtils";

const FilterList = ({ data, onFilterChange, filteredData }) => {
  const [selectedCompany, setSelectedCompany] = useState("");
  const [selectedName, setSelectedName] = useState("");
  const [companies, setCompanies] = useState([]);
  const [cartTotal, setCartTotal] = useState(0);

  const mobileView = isMobile();

  useEffect(() => {
    const uniqueCompanies = [
      ...new Set(
        data.map(
          (item) =>
            `${item.merchant || item.merchant_name}|${item.merchant_logo}`
        )
      ),
    ];

    const companyList = uniqueCompanies.map((company) => {
      const [name, logo] = company.split("|");
      return { name, logo };
    });

    setCompanies(companyList);
  }, [data]);

  useEffect(() => {
    const total = filteredData.reduce((acc, product) => {
      const productExpired = isProductExpired(product);
      const productTotal = !productExpired && product.quantity * product.current_price;
      return productTotal ? acc + productTotal : acc;
    }, 0);
    setCartTotal(total);

  }, [filteredData]);

  const handleCompanyChange = (event) => {
    setSelectedCompany(event.target.value);
    onFilterChange({ company: event.target.value, name: selectedName });
  };

  const handleNameChange = (event) => {
    setSelectedName(event.target.value);
    onFilterChange({ company: selectedCompany, name: event.target.value });
  };

  return (
    <Box sx={{ p: 1 }}>
      <Stack
        direction={mobileView ? "column" : "row"}
        spacing={2}
        justifyContent="space-between"
        sx={{ flexWrap: "wrap" }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: mobileView ? "row" : "column",
            gap: 2,
            width: "100%",
          }}
        >
          <FormControl
            size={mobileView ? "small" : "medium"}
            fullWidth
            sx={{ flex: 1 }}
          >
            <InputLabel>Company</InputLabel>
            <Select
              value={selectedCompany}
              onChange={handleCompanyChange}
              label="Company"
            >
              <MenuItem value="">
                <em>All Companies</em>
              </MenuItem>
              {companies.map((company, index) => (
                <MenuItem key={index} value={company.name}>
                  <img
                    src={company.logo}
                    alt={company.name}
                    style={{
                      width: "30px",
                      height: "30px",
                      marginRight: "10px",
                    }}
                  />
                  {company.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            label="Product Name"
            variant="outlined"
            size={mobileView ? "small" : "medium"}
            fullWidth
            value={selectedName}
            onChange={handleNameChange}
            sx={{ flex: 1 }}
          />
        </Box>
      </Stack>

      {(selectedCompany || selectedName) && (
        <Box sx={{ textAlign: "center", mt: mobileView ? 1 : 2 }}>
          <Button
            variant="outlined"
            color="error"
            onClick={() => {
              setSelectedCompany("");
              setSelectedName("");
              onFilterChange({ company: "", name: "" });
            }}
          >
            Clear Filters
          </Button>
        </Box>
      )}

      <Box mt={mobileView ? 1 : 2} sx={{ flex: 1, textAlign: "center" }}>
        <Typography variant={mobileView ? "p" : "h5"} gutterBottom>
          Cart Total: <b>${cartTotal.toFixed(2)}</b>
        </Typography>
      </Box>
    </Box>
  );
};

export default FilterList;
